export const FETCH_DIRECTIONS_REQUEST = "FETCH_DIRECTIONS_REQUEST";
